import { render, staticRenderFns } from "./applyMy1.vue?vue&type=template&id=0c78679b&scoped=true&"
import script from "./applyMy1.vue?vue&type=script&lang=js&"
export * from "./applyMy1.vue?vue&type=script&lang=js&"
import style0 from "./applyMy1.vue?vue&type=style&index=0&id=0c78679b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c78679b",
  null
  
)

export default component.exports